export default {
  // 在混入对象的 created 钩子函数中注册组件实例并监听其 v-model 变化
  created() {
    if (this.$options.name === 'v-dialog') {
      // 监听 v-model 变化
      this.$watch('value', (newValue) => {
        this.$store.commit('setMaskLayer', newValue)
      })
    }
  },
}
